var React = require('react');

function BucketAdd (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"21","cy":"21","r":"21","fill":"#EBEDF2","key":0}),React.createElement("path",{"d":"M26.691 23.9999L27.802 18.9999H29V16.9999H25.58L21.868 10.5029L20.132 11.4949L23.277 16.9999H14.723L17.868 11.4959L16.132 10.5039L12.42 16.9999H9V18.9999H10.198L12.024 27.2169C12.125 27.6748 12.5311 28.0006 13 27.9999H22V25.9999H13.802L12.247 18.9999H25.754L24.643 23.9999H26.691Z","fill":"#323643","key":1}),React.createElement("path",{"d":"M33 29H30V26H28V29H25V31H28V34H30V31H33V29Z","fill":"#323643","key":2})]);
}

BucketAdd.defaultProps = {"width":"42","height":"42","viewBox":"0 0 42 42","fill":"none"};

module.exports = BucketAdd;

BucketAdd.default = BucketAdd;
